import { useMemo } from 'react';
import axios from 'axios';
import { BITRIX_REST_URL, BITRIX_REST_KEY } from 'constants/api';
import { useLoader, useAlert } from 'hooks';

export const api = axios.create({
  baseURL: BITRIX_REST_URL + BITRIX_REST_KEY,
});

const ApiHelper = ({ children }) => {
  const { startLoader, stopLoader } = useLoader();
  const { setErrorMessage } = useAlert();
  const errText = 'Ошибка';

  useMemo(() => {
    api.interceptors.request.use((config) => {
      startLoader();
      // eslint-disable-next-line no-param-reassign
      config.headers.Accept = 'application/json';

      return config;
    });

    api.interceptors.response.use(
      (res) => {
        stopLoader();

        return res;
      },
      (err) => {
        stopLoader();

        if (typeof err.response !== 'undefined') {
          if (err.response.data.message) {
            setErrorMessage(err.response.data.message);
          } else if (err.response.data.error_description) { setErrorMessage(errText); }
        }

        return Promise.reject(err);
      }
    );
  }, []);

  return children;
};

export default ApiHelper;
